import {
    ApiClientFactory
} from '@/ApiClientFactory';

import {
	CENTRAL_API_URL
} from '../Variables';

let factory = new ApiClientFactory(CENTRAL_API_URL,false);

/**
 *
 * @namespace TenantClient
 */
export const TenantClient = {
    /**
     *
     * Check available tenants for user
     * @param {string} email
     * @returns {Promise<AxiosResponse<*>>}
     */
    getTenants(email) {
        return factory.get(`/central/find-tenants?email=${email}`)
    },

    getTenantsFromSlug(slug) {
        return factory.get(`/central/find-tenants?slug=${slug}`)
    }
};
